import { Browser } from '../legacy'

export const getHasEasy = media => {
    const { version } = Browser.getBrowserData()

    // Because EASY projection can be a bit more resource intensive we're
    // disabling displaying EASY in Internet Explorer and Safari versions below 11.
    if (Browser.is('ie') || (Browser.is('safari') && version < 11)) {
        return false
    }

    // Otherwise determine is EASY should be shown based on API data.
    return media.hasEasy
}
